import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { ModalWarningEventType } from './modal-warning.event.type';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-modal-warning',
	templateUrl: './modal-warning.component.html',
	styleUrls: ['./modal-warning.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ModalWarningComponent implements OnInit, OnDestroy {

	title: string;
	text: string;
	acceptHandler: any;
	acceptHandlerData: any;
	loading = false;
	access: any;
	scheduledGroup = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen( EventTypes.MODAL_WARNING.MODAL_WARNING, data => {
			this.title = data.title;
			this.text = data.text;
			this.scheduledGroup = data.scheduledGroup;
			this.show();
		});

		AppEventDispatcher.listen(EventTypes.MODAL_WARNING.MODAL_CLOSE, data => {
			this.hide();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(EventTypes.MODAL_WARNING.MODAL_CLOSE);
		AppEventDispatcher.removeListener( EventTypes.MODAL_WARNING.MODAL_WARNING);
	}

	show() {
		$('[data-component="modal-warning"]').show();
		TweenMax.to('[data-component="modal-warning"] .modal', 1, {top: '50%', ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to('[data-component="modal-warning"] .modal', .6, {top: '-150%', ease: Quint.easeIn, onComplete: () => {
			$('[data-component="modal-warning"]').hide();
			$('[data-component="modal-warning"]').appendTo('app-modal-warning');
		}});
	}

	accept() {
		AppEventDispatcher.dispatch(ModalWarningEventType.MODAL_WARNING.OK, { title: this.title, text: this.text, scheduledGroup: this.scheduledGroup });
		this.hide();
	}

	cancel() {
		this.hide();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transaction-history/modal-warning/modal-warning.component.ts